module.exports = __webpack_public_path__ + "img/cultureOpen1.c7580e66.png";